import { showUnreadNotifications } from 'src/common/notification/show-notification';

export async function init(sessionId: string) {
  if (sessionStorage.getItem('notificationsSeenBy') !== sessionId) {
    window.sessionStorage.setItem('notificationsSeenBy', sessionId);
    showUnreadNotifications();
  }
}
